<template>
  <v-flex
    xs12
    md6
    xl4
  >
    <v-card
      outlined
      class="mx-auto"
    >
      <v-card-title class="long-title-wrap">
        {{ title }}
      </v-card-title>
      <map-svg :paths="svg" />
      <v-sheet
        v-if="image"
        color="#FFFFFF"
        class="ma-2"
      >
        <!-- !!!!!!!!!!!!!!!!!!!!! -->
        <v-img
          :src="image"
          class="ma-2"
        />
      </v-sheet>
    </v-card>
  </v-flex>
</template>

<script>
export default {
  name: 'Map',
  components: {
    MapSvg: () => import('@/components/MapSvg')
  },
  props: {
    image: {
      default: undefined,
      type: String,
      required: false
    },
    title: {
      type: String,
      required: true
    },
    svg: {
      type: String,
      required: true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
